// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section__padding {
  padding: 4rem 6rem;
}

.flex__center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.app__bg-blue {
  background-color: var(--color-blue);
}
.app__bg-creme {
  background-color: var(--color-creme);
}

.app__wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;

  min-height: 100vh;
}

.app__wrapper_info {
  flex: 1 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}

.app__wrapper_img {
  flex: 1 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  margin-left: 2rem;
}

.app__wrapper_img-reverse {
  justify-content: flex-start;
  margin-right: 2rem;
}

.app__wrapper_img img {
  width: 80%;
}

.custom__button {
  background: linear-gradient(to right, #a07846 0%, #f5dcaf 100%);
  color: var(--color-white);
  font-weight: 700;
  letter-spacing: 0.04em;
  line-height: 28px;
  font-size: 16px;
  padding: 0.5rem 1.5rem;
  margin: 5px;
  border-radius: 15px;
  border: none;
  outline: none;
  cursor: pointer;
}

.p__cormorant {
  font-family: var(--font-base);
  color: var(--color-white);
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: capitalize;
  font-feature-settings: "tnum" on, "lnum" on;
  line-height: 29.9px;
  font-size: 23px;
}

.p__opensans {
  font-family: var(--font-alt);
  color: var(--color-white);
  font-weight: 400;
  letter-spacing: 0.04em;
  text-transform: capitalize;
  line-height: 28px;
  font-size: 16px;
}

.headtext__cormorant {
  color: var(--color-white);
  font-size: 64px;
  line-height: 83.2px;
  letter-spacing: 0.04em;
  text-transform: capitalize;
}

.spoon__img {
  width: 45px;
}

@media screen and (min-width: 2000px) {
  .custom__button,
  .p__cormorant {
    font-size: 37px;
    line-height: 67px;
  }

  .p__opensans {
    font-size: 30px;
    line-height: 50px;
  }

  .headtext__cormorant {
    font-size: 150px;
    line-height: 210px;
  }

  .spoon__img {
    width: 80px;
  }
}

@media screen and (max-width: 1150px) {
  .app__wrapper_img {
    margin: 5rem 0 0 0;
  }

  .app__wrapper_img-reverse {
    margin: 0 0 5rem 0;
  }

  .app__wrapper_img img {
    width: 100%;
  }
}

@media screen and (max-width: 850px) {
  .section__padding {
    padding: 4rem;
  }
}

@media screen and (max-width: 650px) {
  .section__padding {
    padding: 4rem 2rem;
  }

  .p__cormorant {
    font-size: 21px;
  }

  .p__opensans {
    font-size: 14px;
  }
}

@media screen and (max-width: 450px) {
  .p__opensans {
    font-size: 12px;
  }

  .p__cormorant {
    font-size: 19px;
  }

  .headtext__cormorant {
    font-size: 45px;
    line-height: 70px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;;EAEnB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,+DAA+D;EAC/D,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;;IAEE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF","sourcesContent":[".section__padding {\n  padding: 4rem 6rem;\n}\n\n.flex__center {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.app__bg-blue {\n  background-color: var(--color-blue);\n}\n.app__bg-creme {\n  background-color: var(--color-creme);\n}\n\n.app__wrapper {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  min-height: 100vh;\n}\n\n.app__wrapper_info {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  flex-direction: column;\n}\n\n.app__wrapper_img {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  margin-left: 2rem;\n}\n\n.app__wrapper_img-reverse {\n  justify-content: flex-start;\n  margin-right: 2rem;\n}\n\n.app__wrapper_img img {\n  width: 80%;\n}\n\n.custom__button {\n  background: linear-gradient(to right, #a07846 0%, #f5dcaf 100%);\n  color: var(--color-white);\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  line-height: 28px;\n  font-size: 16px;\n  padding: 0.5rem 1.5rem;\n  margin: 5px;\n  border-radius: 15px;\n  border: none;\n  outline: none;\n  cursor: pointer;\n}\n\n.p__cormorant {\n  font-family: var(--font-base);\n  color: var(--color-white);\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: capitalize;\n  font-feature-settings: \"tnum\" on, \"lnum\" on;\n  line-height: 29.9px;\n  font-size: 23px;\n}\n\n.p__opensans {\n  font-family: var(--font-alt);\n  color: var(--color-white);\n  font-weight: 400;\n  letter-spacing: 0.04em;\n  text-transform: capitalize;\n  line-height: 28px;\n  font-size: 16px;\n}\n\n.headtext__cormorant {\n  color: var(--color-white);\n  font-size: 64px;\n  line-height: 83.2px;\n  letter-spacing: 0.04em;\n  text-transform: capitalize;\n}\n\n.spoon__img {\n  width: 45px;\n}\n\n@media screen and (min-width: 2000px) {\n  .custom__button,\n  .p__cormorant {\n    font-size: 37px;\n    line-height: 67px;\n  }\n\n  .p__opensans {\n    font-size: 30px;\n    line-height: 50px;\n  }\n\n  .headtext__cormorant {\n    font-size: 150px;\n    line-height: 210px;\n  }\n\n  .spoon__img {\n    width: 80px;\n  }\n}\n\n@media screen and (max-width: 1150px) {\n  .app__wrapper_img {\n    margin: 5rem 0 0 0;\n  }\n\n  .app__wrapper_img-reverse {\n    margin: 0 0 5rem 0;\n  }\n\n  .app__wrapper_img img {\n    width: 100%;\n  }\n}\n\n@media screen and (max-width: 850px) {\n  .section__padding {\n    padding: 4rem;\n  }\n}\n\n@media screen and (max-width: 650px) {\n  .section__padding {\n    padding: 4rem 2rem;\n  }\n\n  .p__cormorant {\n    font-size: 21px;\n  }\n\n  .p__opensans {\n    font-size: 14px;\n  }\n}\n\n@media screen and (max-width: 450px) {\n  .p__opensans {\n    font-size: 12px;\n  }\n\n  .p__cormorant {\n    font-size: 19px;\n  }\n\n  .headtext__cormorant {\n    font-size: 45px;\n    line-height: 70px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
